module.exports = __webpack_public_path__ + "img/SALE.efb8785d.svg";